import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ConfigurationService } from '@draeger-academy/common';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { PortalConfigurationService } from '@draeger-academy/common/lib/services/portal-configuration/portal-configuration.service';

@Component({
    selector: 'da-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginComponent implements OnInit {
    public targetLink: any = null;
    constructor(
        private _localizeRouterService: LocalizeRouterService,
        private _configurationService: ConfigurationService,
        private _portalConfigurationService: PortalConfigurationService
    ) {}

    ngOnInit() {
        if (this._configurationService.isPartnerPage()) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                this.targetLink = '/partner/' + portalId + '/account';
            });
        } else {
            this.targetLink = this._localizeRouterService.translateRoute('/login');
        }
    }
}
